import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'anticipatedClosingDate',
    label: 'Anticipated Closing Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstCloseAt',
    label: 'First closing date and time',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closeAt',
    label: 'Closing date and time (or Second closing date and time)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'location',
    label: 'Closing location',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'interestCreditNoteDate',
    label: 'Note Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'interestCreditFundingDate',
    label: 'Funding Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'interestCreditDisbursementDate',
    label: 'Disbursement Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'interestCreditFirstPaymentDate',
    label: 'First Payment Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'approvalDate',
    label: 'Approval Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'approvalExpirationDate',
    label: 'Approval Expiration Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const closingInformationForm = {
  name: FormNames.CLOSING_INFORMATION,
  label: 'Closing Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
